import { render, staticRenderFns } from "./Course1.vue?vue&type=template&id=74073152&scoped=true"
import script from "./Course1.vue?vue&type=script&lang=ts"
export * from "./Course1.vue?vue&type=script&lang=ts"
import style0 from "@/assets/css/course.css?vue&type=style&index=0&id=74073152&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74073152",
  null
  
)

export default component.exports